import { Color, Flex, Icon, Spacing, Tag, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import type { QuestionHoverContent } from '../../types'

interface ReviewEntryQuestionHoverPopoverProps {
  content: QuestionHoverContent
}

export const ReviewEntryQuestionHoverPopover = ({ content }: ReviewEntryQuestionHoverPopoverProps): ReactElement => {
  const { headerTitle, message, showSparkleHeader, tags } = content

  return (
    <Flex flexDirection="column" gap={Spacing.S20}>
      <Flex flexDirection="column" gap={Spacing.S6}>
        {headerTitle ? (
          <Flex alignItems="center" gap={Spacing.S6}>
            {showSparkleHeader ? <Icon color={Color.Purple600} icon="sparkle" size="xs" /> : null}
            <Text as="span" color={Color.Grey950} variant="bodyMD" weight="semiBold">
              {headerTitle}
            </Text>
          </Flex>
        ) : null}
        {tags.map((tag, index) => (
          <Tag color={tag.color} icon={tag.icon} key={`${tag.label}-${index}`} size="sm" type="subtle">
            {tag.label}
          </Tag>
        ))}
      </Flex>
      {message
        ? message.split('\n\n').map((paragraph, index) => (
            <Text as="p" color={Color.Grey950} key={index} variant="bodyMD">
              {paragraph}
            </Text>
          ))
        : null}
    </Flex>
  )
}
